import { render, staticRenderFns } from "./StorePointReports.vue?vue&type=template&id=f22564da&scoped=true"
import script from "./StorePointReports.vue?vue&type=script&lang=js"
export * from "./StorePointReports.vue?vue&type=script&lang=js"
import style0 from "./StorePointReports.vue?vue&type=style&index=0&id=f22564da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22564da",
  null
  
)

export default component.exports